//=> Import React
import React from 'react';

// Import Plugins =>
import { Link } from 'gatsby'


//=> Import Styles
import { article, content, title, priceContainer, priceCss, button, btnLink, bgImage, description } from "./styles.module.scss"

const ProductCard = ({ name, price, image, slug, description, }) => {


  // Reduce Description
  const shortDescription = description.split(' ')
  shortDescription.splice(15, description.length - 15, '...')

  // Je veux retirer tous les caractère "Markdown" pour afficher la descripion dans la carte
  const regex = /#|\*|<br>/ig
  const newDescription = shortDescription.join(' ').replaceAll(regex, '')


  const imageCover = image[0].file.url

  return (
    <article className={article}>
      <div

        className={bgImage}
        style={{ backgroundImage: `url(${imageCover})` }}
        title={name}
        aria-label={name}
      />
      <div className={content}>
        <h4 className={title}>{name}</h4>
        <p className={description}>{newDescription}</p>

        <div className={priceContainer}>
          <div className={priceCss}>{price}€</div>
          <Link className={btnLink} to={`/product/${slug}`} title={`${name}`} >
            <button className={button}>En savoir plus</button>
          </Link>
        </div>

      </div>

    </article>
  )
}

export default ProductCard